import type { TaskBucket } from "../types";

/** Mission Control task tab buckets (``in_progress`` is a URL alias only — same rows as ``working``). */
export const MISSION_CONTROL_TAB_BUCKETS: TaskBucket[] = [
  "needs_me",
  "blocked",
  "needs_review",
  "working",
  "queued",
  "recent",
  "all",
];

/** Normalise legacy / deep-link bucket ids to a tab bucket used for list fetches. */
export function normalizeMissionControlTabBucket(bucket: TaskBucket): TaskBucket {
  return bucket === "in_progress" ? "working" : bucket;
}

const NEEDS_ME_STATUSES = new Set(["needs_review", "blocked"]);
const QUEUED_STATUSES = new Set(["queued", "gated", "publish_failed"]);
const RECENT_STATUSES = new Set(["done", "auto_closed"]);

/** Whether a task status belongs in the given Mission Control bucket. */
export function taskStatusBelongsInBucket(status: string, bucket: TaskBucket): boolean {
  switch (bucket) {
    case "needs_me":
      return NEEDS_ME_STATUSES.has(status);
    case "blocked":
      return status === "blocked";
    case "needs_review":
      return status === "needs_review";
    case "working":
    case "in_progress":
      return status === "working";
    case "queued":
      return QUEUED_STATUSES.has(status);
    case "recent":
      return RECENT_STATUSES.has(status);
    case "all":
      return true;
    default:
      return false;
  }
}
